<div class="auth-wrapper">
  <div class="testimonial-div">
    <div class="my-4">
      <h3 class="text-gray lh-50">
        <b>Fast, flexible and secure</b> international money transfers across
        the world.
      </h3>
    </div>
    <div class="my-4">
      <div class="d-flex align-items-center mt-1-25 mb-5">
        <img src="assets/images/service.svg" alt="service" class="flash-icon" />
        <div class="ms-4">
          <p class="h5 text-gray mb-0"><b>easy</b> to navigate platform</p>
          <p class="text-gray mb-0">
            enter your email address and password to access the platform
          </p>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <img
          src="assets/images/business-and-finance.svg"
          alt="business-and-finance"
          class="flash-icon" />
        <div class="ms-4">
          <p class="h5 text-gray mb-0">manage <b>remittance</b> platform</p>
        </div>
      </div>
    </div>
  </div>
  <div class="form-div">
    <img src="" class="logo mb-5" alt="" />
    <p class="text-gray h3 mb-4">
      <b>Login</b> to your
      <!-- XBP -->
      <b>account</b>
    </p>
    <form [formGroup]="loginForm">
      <app-auth-input
        [inputData]="attributeConstant.email"
        [formControlName]="attributeConstant.email.key">
      </app-auth-input>
      <app-auth-input
        [inputData]="attributeConstant.password"
        [formControlName]="attributeConstant.password.key">
      </app-auth-input>
      <h6 class="mt-1-25 mb-1-25">
        <a routerLink="/auth/forgot-password" class="auth-hyperlink">
          Forgot password?
        </a>
      </h6>
      <button class="btn primary-btn w-100" (click)="onSubmit()">
        Sign In
      </button>
    </form>
  </div>
</div>
